export function formatScheduleDraftError(error, fallback = "操作失败") {
    const data = error?.response?.data;
    const detail = data?.detail ?? data?.message;
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || error?.response?.config?.url;

    if (status === 404 && (!detail || detail === "Not Found")) {
        return `${fallback}：接口或资源不存在${requestUrl ? `（${requestUrl}）` : ""}`;
    }

    if (typeof detail === "string" && detail.trim()) {
        return detail;
    }

    if (Array.isArray(detail) && detail.length) {
        const message = detail
            .map((item) => {
                if (typeof item === "string") {
                    return item;
                }
                const location = Array.isArray(item?.loc) ? item.loc.join(".") : item?.loc;
                const itemMessage = item?.msg || item?.message;
                return [location, itemMessage].filter(Boolean).join(": ");
            })
            .filter(Boolean)
            .join("; ");
        return message || fallback;
    }

    if (detail && typeof detail === "object") {
        const issues = Array.isArray(detail.issues) ? detail.issues : [];
        const issueText = issues
            .slice(0, 3)
            .map((issue) => {
                const flight = issue?.flight && typeof issue.flight === "object" ? issue.flight : {};
                const flightLabel = issue?.flight_number || flight.flight_number || issue?.flight_id || issue?.affected_flight_ids?.[0];
                const action = issue?.next_action || issue?.suggestion;
                return [issue?.constraint_label || issue?.code, flightLabel, issue?.message, action ? `下一步：${action}` : null].filter(Boolean).join(" · ");
            })
            .filter(Boolean)
            .join("；");
        return [detail.message || detail.msg, issueText].filter(Boolean).join("：") || JSON.stringify(detail);
    }

    if (typeof error?.message === "string" && error.message.trim()) {
        return error.message;
    }

    return fallback;
}
